import React from 'react';
import { ExecutionLineItemTrpcResponse } from 'shared/src/trpc-types/line-item-trpc-types';
import { MediaIcon } from '@/icons/media-icon';
import { OutlineButton } from '@/components/display/button';

type Props = {
  data: ExecutionLineItemTrpcResponse;
  setIsEditing: (lineItemId: string) => void;
};

export function ExecutionLineItemActions({ data, setIsEditing }: Props) {
  return (
    <div className="relative">
      <div
        className={
          'shadow-l-lg fixed right-0 h-full border-l border-gray-200 bg-white px-2 transition-[width]'
        }>
        <div className="flex h-full w-full items-center justify-center gap-1.5">
          <OutlineButton
            data-tooltip-id={`edit-line-item-${data.id}`}
            onClick={() => setIsEditing(data.id)}>
            <div className="flex items-center">
              <MediaIcon />
              <div className="ml-2">Media Update</div>
            </div>
          </OutlineButton>
        </div>
      </div>
    </div>
  );
}
